// extracted by mini-css-extract-plugin
module.exports = {"header":"ServicesRegionalCapabilities_header__OvMo5","search-fade-in":"ServicesRegionalCapabilities_search-fade-in__KvdkX"};